import { environment } from "../environmentals/config";

export const ipfsUri = (cid: string): string => cid? environment.ipfsGateway.replace('~cid~', cid) : ''